import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

@Component({
  selector: 'app-annuaire-single',
  templateUrl: './single.component.html',
  styleUrls: ['./single.component.css']
})
export class SingleComponent implements OnInit {
  entreprise;
  contacts;

  dateFormatted = '';

  constructor(private _router: ActivatedRoute, private router: Router) {
    this._router.data
      .subscribe((data: { entreprise: any }) => {
        console.log(data, data.entreprise);
        this.entreprise = data.entreprise.entreprise;
        this.contacts = data.entreprise.contacts;

        if (this.entreprise.date_creation != null) {
          var split = this.entreprise.date_creation.split('-');
          this.dateFormatted = split[2] + '/' + split[1] + '/' + split[0];
        } else {
          this.dateFormatted = '';
        }
      });
  }

  ngOnInit() {
    var elements = document.getElementsByClassName('annuaire-eco-entreprise-breadcrump');

    if (elements.length != 0) {
      elements[0].scrollIntoView();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/annuaire/single/single.component.ts